import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMacintosh: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconMacintosh"><Path d="M5.5 18.5H4.5V2.5H19.5V18.5H18.5M5.5 18.5V21.5H18.5V18.5M5.5 18.5H18.5M13.5 15.5H16.5M7.5 5.5H16.5V12.5H7.5V5.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconMacintosh;
